"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowCheckBoxEditor_1 = require("../../../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var AffilateBrandEditor = /** @class */ (function (_super) {
    __extends(AffilateBrandEditor, _super);
    function AffilateBrandEditor(props) {
        return _super.call(this, props) || this;
    }
    AffilateBrandEditor.prototype.getPriorityAvail = function () {
        var _ret = [];
        for (var i = 1; i <= 10; i++) {
            _ret.push({
                key: i,
                value: "\u041D\u043E\u043C\u0435\u0440-" + i,
            });
        }
        return _ret;
    };
    AffilateBrandEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    brand_id: _item.brand_id,
                    brand_title: _item.brand_title,
                    is_deprecated: _item.is_deprecated,
                    order_number_key: _item.order_number,
                    order_number_val: "\u041D\u043E\u043C\u0435\u0440-" + _item.order_number,
                    order_number_avail: this.getPriorityAvail()
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Настройки П.Программы", "Редактирование бренда"]);
                });
            }
        }
        else {
            this.setState({
                brand_id: 0,
                brand_title: "",
                is_deprecated: false,
                order_number_key: 1,
                order_number_val: "\u041D\u043E\u043C\u0435\u0440-" + 1,
                order_number_avail: this.getPriorityAvail()
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Настройки П.Программы", "Создание бренда"]);
            });
        }
        this.doReSetRules();
    };
    AffilateBrandEditor.prototype.doReSetRules = function () {
        this.setState({
            brand_rules: { isError: false },
            order_number_rules: { isError: false }
        });
    };
    AffilateBrandEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.brand_id <= 0) || (this.state.brand_title.length === 0)) {
            this.setState({ brand_rules: { isError: true, errorMessage: "Бренд партнерской программы не выбран!" } });
            return false;
        }
        if ((this.state.order_number_key <= 0) || (this.state.order_number_val.length === 0)) {
            this.setState({ order_number_rules: { isError: true, errorMessage: "Поле [Порядковый номер] не выбрано!" } });
            return false;
        }
        return true;
    };
    AffilateBrandEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                brand_id: this.state.brand_id,
                affilate_id: this.props.rootRecord.key,
                is_deprecated: this.state.is_deprecated,
                order_number: this.state.order_number_key
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Бренд партнерской программы добавлен!");
            });
        }
    };
    AffilateBrandEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    AffilateBrandEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Новый бренд П.Программы";
        }
        else {
            return "Изменить бренд П.Программы";
        }
    };
    AffilateBrandEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 330 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Бренд:", placeholder: "Выберите бренд" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        brand_rules: { isError: false }
                    });
                }, items: this.props.availBrands, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Порядковый номер:", placeholder: "Выберите порядковый номер" }, value: { key: this.state.order_number_key, value: this.state.order_number_val }, onValueChanged: function (newVal) {
                    _this.setState({
                        order_number_key: newVal.key,
                        order_number_val: newVal.value,
                        order_number_rules: { isError: false }
                    });
                }, items: this.state.order_number_avail, required: true, rules: this.state.order_number_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Бренд устарел", value: this.state.is_deprecated, onChecked: function (checked) { _this.setState({ is_deprecated: checked }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this) })));
    };
    return AffilateBrandEditor;
}(React.Component));
exports.default = AffilateBrandEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ui/component/config/brands/AffilateBrandEditor.tsx
// module id = 2021
// module chunks = 0